import * as rdd from "react-device-detect";

const useIsMobile = () => {
  return rdd.isMobile;
};

export default useIsMobile;
